@if (!data.node.isAsset) {
  <h1 mat-dialog-title>
    {{'group.delete_group_title' | transloco}}
  </h1>
  <div mat-dialog-content>
    {{'group.delete_group_confirmation_title' | transloco:{'value':data.node.name} }}
  </div>
}
@if (data.node.isAsset) {
  <h1 mat-dialog-title>
    {{'group.remove_asset_from_group_title' | transloco}}
  </h1>
  <div mat-dialog-content>
    {{'group.remove_asset_from_group_description' | transloco }}
  </div>
}
<div mat-dialog-actions>
  <button mat-button (click)="cancel()">
    {{'operations.cancel' | transloco}}
  </button>
  <button mat-stroked-button color="warn" (click)="confirmDeletion()">
    {{'operations.confirm' | transloco}}
  </button>
</div>
